import { IBarcode } from '@app/models/barcode.interface';
import { IReceiving } from '@app/models/receiving.interface';
import { createAction, props } from '@ngrx/store';

export const loadReceivings = createAction(
  '[Receivings] Load Receivings',
  props<any>()
);

export const loadReceivingsSuccess = createAction(
  '[Receivings] Load Receivings Success',
  props<{ receivings: IReceiving[], total: number }>()
);

export const loadReceivingsFailure = createAction(
  '[Receivings] Load Receivings Failure',
  props<{ error: any }>()
);

export const filterByCategory = createAction(
  '[Receivings] Filter Receivings By Category',
  props<{ prdCatID: number, active: string, direction: string }>()
);

export const filterByCategorySuccess = createAction(
  '[Receivings] Filter Receivings By Category Success',
  props<any>()
);

export const filterByCategoryFailure = createAction(
  '[Receivings] Filter Receivings By Category Failure',
  props<{ error: any }>()
);

export const saveReceiving = createAction(
  '[Receivings] Save Receiving',
  props<{ form: any }>()
);

export const saveReceivingSuccess = createAction(
  '[Receivings] Save Receiving Success',
  props<any>()
);

export const saveReceivingFailure = createAction(
  '[Receivings] Save Receiving Failure',
  props<{ error: any }>()
);

export const updateReceiving = createAction(
  '[Receivings] Update Receiving',
  props<{ form: any }>()
);

export const updateReceivingSuccess = createAction(
  '[Receivings] Update Receiving Success',
  props<{ receiving: any }>()
);

export const updateReceivingFailure = createAction(
  '[Receivings] Update Receiving Failure',
  props<{ error: any }>()
);

export const loadReceiving = createAction(
  '[Receivings] Load Receiving',
  props<{ productMovementHistoryID: any }>()
);

export const loadReceivingSuccess = createAction(
  '[Receivings] Load Receiving Success',
  props<{ receiving: any }>()
);

export const loadReceivingFailure = createAction(
  '[Receivings] Load Receiving Failure',
  props<{ error: any }>()
);

export const filterByArea = createAction(
  '[Receivings] Filter Receivings By Area',
  props<{ prdAreaID: number, active: string, direction: string }>()
);

export const filterByAreaSuccess = createAction(
  '[Receivings] Filter Receivings By Area Success',
  props<any>()
);

export const filterByAreaFailure = createAction(
  '[Receivings] Filter Receivings By Area Failure',
  props<{ error: any }>()
);

export const search = createAction(
  '[Receivings] Search',
  props<{ query: string}>()
);

export const searchSuccess = createAction(
  '[Receivings] Search Success',
  props<{ receivings: IReceiving[], total: number}>()
);

export const searchFailure = createAction(
  '[Receivings] Search Failure',
  props<{ error: any }>()
);

export const incrementPage = createAction(
  '[Receivings] Increment Pagination',
  props<{ currentPage: any }>()
);

export const resetPage = createAction(
  '[Receivings] Reset Pagination'
);

export const resetReceivings = createAction(
  '[Receivings] Reset Receivings'
);

export const incrementPageSuccess = createAction(
  '[Receivings] Increment Pagination Success',
  props<{ currentPage: any }>()
);

export const decrementPage = createAction(
  '[Receivings] Decrement Pagination'
);

export const setBarcodeType = createAction(
  '[Receivings] Set Barcodes',
  props<{ data: any }>()
);

export const loadBarcodeType = createAction(
  '[Receivings] Load Barcodes',
  props<{ data: any }>()
);

export const setFilterType = createAction(
  '[Receivings] Set Filter Type',
  props<{ filterType: string, filterID: number }>()
);

export const setSelected = createAction(
  '[Receivings] Set Selected',
  props<{ selected: any }>()
);

export const setSort = createAction(
  '[Receivings] Set Sort',
  props<{ sort: string, direction: string, query: string }>()
);

export const resetReceiving = createAction(
  '[Receivings] Reset Receiving'
);

export const resetFilter = createAction(
  '[Receivings] Reset Filter'
)

export const setDeselected = createAction(
  '[Receivings] Set Deselected'
);

export const deleteReceivings = createAction(
  '[Receivings] Delete Receivings',
  props<any>()
);

export const deleteReceivingsSuccess = createAction(
  '[Receivings] Delete Receivings Success',
  props<any>()
);

export const deleteReceivingsFailure = createAction(
  '[Receivings] Delete Receivings Failure',
  props<{ error: any }>()
);

export const deleteReceiving = createAction(
  '[Receivings] Delete Receiving',
  props<{productMovementHistoryID: number,reason:string }>()
);

export const deleteReceivingSuccess = createAction(
  '[Receivings] Delete Receiving Success',
  props<any>()
);

export const deleteReceivingFailure = createAction(
  '[Receivings] Delete Receiving Failure',
  props<{ error: any }>()
);

export const createBarcode = createAction(
  '[Receivings] Create Barcode',
  props<{barcodeData: string, productMovementHistoryID: number }>()
);

export const createBarcodeSuccess = createAction(
  '[Receivings] Create Barcode Success',
  props<any>()
);

export const createBarcodeFailure = createAction(
  '[Receivings] Create Barcode Failure',
  props<{ error: any }>()
);

export const setBarcodes = createAction(
  '[Receivings] Set Barcode',
  props<{barcodes: IBarcode[] }>()
);

export const setSelectedBarcode = createAction(
  '[Receivings] Set Selected Barcode',
  props<{ index: number }>()
)

export const deleteBarcode = createAction(
  '[Receivings] Delete Barcode',
  props<{barcodeID: number }>()
);

export const deleteBarcodeSuccess = createAction(
  '[Receivings] Delete Barcode Success',
  props<any>()
);

export const deleteBarcodeFailure = createAction(
  '[Receivings] Delete Barcode Failure',
  props<{ error: any }>()
);

export const exportReceivings = createAction(
  '[Receivings] Export Receivings'
);

export const sortByCategory = createAction(
  '[Receivings] Sort By Category Receivings',
  props<{ active: string, direction:string, category: number }>()
);

export const sortByCategorySuccess = createAction(
  '[Receivings] Sort By Category Receivings Success',
  props<any>()
);

export const sortByCategoryFailure = createAction(
  '[Receivings] Sort By Category Receivings Failure',
  props<{ error: any }>()
);

export const setIsLoading = createAction(
  '[Receivings] Set Is Loading',
  props<{ isLoading: boolean }>()
);

